module.exports = __webpack_public_path__ + "static/img/rank_226.3e92074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_226.png
// module id = zOmR
// module chunks = 0